import {createSlice, createAsyncThunk}		from '@reduxjs/toolkit';

import {Support, SupportState}						from './interface';
import actions 								from './supportAction';


const initialState: SupportState = {
	isLoad:    false,
	data:      []
};

export const getSupportsApi = createAsyncThunk('support/getSupportApi', actions.getSupportApi);
export const postSupportsApi = createAsyncThunk('support/postSupportsApi', actions.postSupportApi);
export const closeSupportsApi = createAsyncThunk('support/closeSupportsApi', actions.closeSupportApi);
export const noticeSupportsApi = createAsyncThunk('support/noticeSupportsApi', actions.noticeSupportApi);
export const postSupportMessageApi = createAsyncThunk('support/postSupportMessageApi', actions.postSupportMessageApi);

export const Reducer = createSlice({
	name:     'support',
	initialState,
	reducers: {
	},
	extraReducers: (builder) => {
		builder
		// --- GET
		.addCase(getSupportsApi.pending, (state) => {
			state.isLoad = true;
		})
		.addCase(getSupportsApi.fulfilled, (state, action) => {
			return ({
				isLoad: false,
				data:   action.payload
			});
		})
		// --- PUT
		.addCase(closeSupportsApi.fulfilled, (state, action) => {
			if (!action.payload?._id)
				return ({...state, isLoad: false});

			const copy: Support[] = state.data.map((support) => {
				if (support && action.payload._id === support._id)
					return {...support, ...action.payload};
				return support;
			});

			return ({
				...state,
				data:   copy,
				isLoad: false
			});
		})
		.addCase(noticeSupportsApi.fulfilled, (state, action) => {
			if (!action.payload?._id)
				return ({...state, isLoad: false});

			const copy: Support[] = state.data.map((support) => {
				if (support && action.payload._id === support._id)
					return {...support, ...action.payload};
				return support;
			});

			return ({
				...state,
				data:   copy,
				isLoad: false
			});
		})
		// --- POST
		.addCase(postSupportsApi.fulfilled, (state, action) => {
			if (action.payload)
				state.data.push(action.payload);
		});
	}
});

export default Reducer.reducer;
